import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { POSSettingsModel } from '../Shared/Interfaces/IPOSSettings';

@Injectable({
    providedIn: 'root',
})
export class PosSettingsService {
    private baseURL: string;
    public pOSSetting: POSSettingsModel;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    private useQboForCheckPrintingSubject = new BehaviorSubject<boolean>(false);

    useQboForCheckPrinting$ = this.useQboForCheckPrintingSubject.asObservable();

    setUseQboForCheckPrinting(value: boolean): void {
        this.useQboForCheckPrintingSubject.next(value);
    }

    // POS Settings
    getPosSettings(): Observable<POSSettingsModel> {
        return this.http.get<any>(
            `${this.baseURL}/POSSettings/GetPosSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => { this.pOSSetting = res.body; return this.pOSSetting; }),
            catchError(this.handleError)
        );
    }

    savePosSettings(posSettings: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/POSSettings/SavePosSettingsDetails`,
            posSettings,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // POS Sales Tax Settings
    getSalesTaxAndCommission(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/POSSettings/GetPOSSalesTaxAndCommission`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    saveSalesTaxAndCommission(salesTaxSettings: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/POSSettings/SaveSalesTaxAndCommissionDetails`,
            salesTaxSettings,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // POS Message Settings
    getMessageSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/POSSettings/GetMessageSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    saveMessageSettings(messageSettings: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/POSSettings/SaveMessageSettingsDetails`,
            messageSettings,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getDefaultPOSCommissions(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/POSSettings/GetDefaultPOSCommissions`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
